import { FC } from 'react'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { border } from '../layout/theme/border'

const PREFIX = 'xxllncJsonView'

const classes = {
  root: `${PREFIX}-root`,
}

interface JsonViewProps {
  value: unknown
}

export const JsonView: FC<JsonViewProps> = ({ value }) => (
  <StyledBox className={classes.root}>
    {JSON.stringify(value ?? {}, null, 2)}
  </StyledBox>
)

const StyledBox = styled(Box)(() => ({
  [`&.${classes.root}`]: {
    margin: 0,
    padding: 12,
    borderRadius: border.radius.sm,
    border: `${border.thin} solid ${border.light}`,
    backgroundColor: 'rgba(0,0,0,0.02)',
    fontFamily: 'monospace',
    fontSize: 12,
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowX: 'auto',
  },
}))
